import { Container, Grid, Typography, makeStyles } from "@material-ui/core";
import { getDeliveryWindow, getOrderDate } from "../utils";

import { ITheme } from "../constants/theme";
import React from "react";
import { useTranslation } from 'react-i18next';

export const OrderDetailsBasicInfoSection = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const data: any = props.data;
  return (
    <Container className={classes.basicInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
            {t('orderDetails.basicInformation')}
          </Typography>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
              data-automation="order-id-main"
            >
              {t('orderDetails.orderId')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.OrderNo}
            </Typography>
          </Grid>
        </Grid>
        {data && data.ExternalOrderId?.length > 0 ?
          <Grid container className={classes.infoTextContainer}>
            <Grid item xs={3}>
              <Typography
                display="inline"
                variant="caption"
                component="span"
                color="textSecondary"
                data-automation="order-id-main"
              >
                {t('orderDetails.externalOrderId')}
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.colOffset}>
              <Typography variant="body1" component="span" color="textPrimary">
                {data.ExternalOrderId}
              </Typography>
            </Grid>
          </Grid>
          : null}
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.orderDate')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {getOrderDate(data?.Created)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.deliveryWindow')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {getDeliveryWindow(data?.TimeSlotFrom, data?.TimeSlotTo)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid
            container
            item
            xs={3}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.deliveryAddress')}
            </Typography>
          </Grid>
          <Grid item xs={9} className={classes.colOffset}>
            <Grid item xs={12}>
              <Typography variant="body1" component="span" color="textPrimary">
                {GetAddressLine(data)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.deliveryInstructions')}
            </Typography>
          </Grid>
          <Grid item xs={9} className={classes.colOffset}>
            {data.DeliveryAddressInstructions !== "" ? (
              <Typography variant="body1" component="span" color="textPrimary">
                {data.DeliveryAddressInstructions}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                component="span"
                color="textSecondary"
              >
                {t('orderDetails.notAvailable')}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.nameOnDoorbell')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            {data.DeliveryAddressNameOnDoor !== "" ? (
              <Typography variant="body1" component="span" color="textPrimary">
                {data.DeliveryAddressNameOnDoor}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                component="span"
                color="textSecondary"
              >
                {t('orderDetails.notAvailable')}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainerLastRow}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.pickupInstructions')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            {data.PickupInstructions && data.PickupInstructions !== "" ? (
              <Typography variant="body1" component="span" color="textPrimary">
                {data.PickupInstructions}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                component="span"
                color="textSecondary"
              >
                {t('orderDetails.notAvailable')}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
const GetAddressLine = (data: any) => {
  const addressLines =
    (data?.DeliveryAddressLine2 === null || data?.DeliveryAddressLine2 === ""
      ? ""
      : " " + data?.DeliveryAddressLine2) +
    (data?.DeliveryAddressLine3 === null || data?.DeliveryAddressLine3 === ""
      ? ""
      : " " + data?.DeliveryAddressLine3);
  const addressLineWhiteSpace = addressLines.length === 0 ? "" : " ";
  return (
    data?.DeliveryAddressLine1.trim() +
    ", " +
    addressLines +
    addressLineWhiteSpace +
    data.DeliveryAddressCity +
    " " +
    data.DeliveryAddressPostCode +
    ", " +
    data.DeliveryAddressCounty
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  basicInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
